import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { List, X, WhatsappLogo } from "@phosphor-icons/react";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/products", label: "Products" },
  { to: "/how-it-works", label: "How Delivery Works" },
  { to: "/about", label: "About Us" },
  { to: "/contact", label: "Contact" },
];

export default function PublicNav() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  const portalTarget = user && user.role === "admin" ? "/admin" : "/portal";

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-[#E5E7EB]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="flex h-16 items-center justify-between gap-4">
          <Logo />
          <nav className="hidden lg:flex items-center gap-8">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `text-sm font-medium transition-colors hover:text-[#0A4F35] ${
                    isActive ? "text-[#0A4F35]" : "text-slate-600"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
          <div className="hidden lg:flex items-center gap-3">
            {user ? (
              <Button
                data-testid="nav-portal-btn"
                onClick={() => navigate(portalTarget)}
                className="bg-[#0A4F35] hover:bg-[#083D29] text-white"
              >
                My Dashboard
              </Button>
            ) : (
              <Link to="/login" data-testid="nav-login-btn" className="text-sm font-semibold text-[#0A4F35] hover:underline">
                Customer Login
              </Link>
            )}
            <Button
              data-testid="nav-request-fuel-btn"
              onClick={() => navigate("/request-fuel")}
              className="bg-[#E5B800] hover:bg-[#CCA300] text-black font-semibold"
            >
              Request Fuel
            </Button>
          </div>
          <button
            data-testid="nav-mobile-toggle"
            className="lg:hidden p-2 text-slate-700"
            onClick={() => setOpen((v) => !v)}
            aria-label="Menu"
          >
            {open ? <X size={26} /> : <List size={26} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-[#E5E7EB] bg-white px-4 py-4 space-y-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block rounded-md px-3 py-2 text-base font-medium ${
                  isActive ? "bg-[#0A4F35]/10 text-[#0A4F35]" : "text-slate-700"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <div className="pt-3 space-y-2">
            <Button
              onClick={() => { setOpen(false); navigate("/request-fuel"); }}
              className="w-full bg-[#E5B800] hover:bg-[#CCA300] text-black font-semibold"
            >
              Request Fuel
            </Button>
            <Button
              variant="outline"
              onClick={() => { setOpen(false); navigate(user ? portalTarget : "/login"); }}
              className="w-full border-[#0A4F35] text-[#0A4F35]"
            >
              {user ? "My Dashboard" : "Customer Login"}
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
